"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserDetailsContracts = void 0;
const user_details_1 = require("@app/reducer/user-details");
const store_1 = require("@app/store");
const user_details_contracts_1 = require("../../request/user-details-contracts");
const employee_card_context_1 = require("../employee-card-context");
const useEmployeeCardData_1 = require("./useEmployeeCardData");
const useUserDetailsContracts = () => {
    const { workspace, userId } = (0, employee_card_context_1.useEmployeeCard)();
    const dispatch = (0, store_1.useRootDispatch)();
    const { data } = (0, useEmployeeCardData_1.useEmployeeCardData)({
        actionName: 'user-details-contracts',
        requestor: async () => await (0, user_details_contracts_1.requestUserDetailsContracts)({
            workspaceId: workspace?.id ?? '',
            userId: userId ?? '',
        }),
        reducer: (data) => dispatch((0, user_details_1.setUserContracts)(data?.contracts)),
        selector: (state) => state.userDetails.contracts,
        listenDeps: [workspace?.id, userId],
    });
    return data;
};
exports.useUserDetailsContracts = useUserDetailsContracts;
